import {getCSRF_Token} from "@/fonction/logConnection";

import {callApi} from "./_callApi";

/**
 * Vérifie la connexion à l'API
 * @param bff - URL de l'API
 * @returns - Réponse de l'API
 */
export async function logCheck(bff: string | undefined): Promise<{
  personnel_id: number;
  droits: {
    [key: string]: boolean;
  };
}> {
  try {
    if (!bff) {
      throw new Error("BFF is not provided.");
    }
    return await callApi(
      `${bff}/healthcheck`,
      "GET",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      null
    );
  } catch (error: any) {
    throw new Error(
      `Erreur lors de la vérification de la connexion: ${error?.message}`
    );
  }
}

/**
 * Déconnecte l'utilisateur
 * @param bff - URL de l'API
 * @returns - Réponse de l'API
 */
export async function logout(bff: string | undefined): Promise<Response> {
  try {
    if (!bff) {
      throw new Error("BFF is not provided.");
    }
    return await callApi(
      `${bff}/logout`,
      "GET",
      {
        "X-Requested-With": "XMLHttpRequest",
      },
      "include",
      null,
      false
    );
  } catch (error: any) {
    throw new Error(`Erreur lors de la déconnexion: ${error?.message}`);
  }
}
